<template>
  <div
    class="border-top border-bottom border-dark"
    style="display:flex; background-color:rgb(204,255,179)"
  >
    <div
      class="p-1 column65 text-center text-bold border-left border-right border-dark "
    >
      TINGKAT RISIKO PEMENUHAN
    </div>
    <div class="p-1 column15 text-center text-bold border-right border-dark">
      {{ kategori }}
    </div>
    <div
      class="p-1 border-right border-dark"
      style="height: auto;width:20%"
    ></div>
  </div>
</template>
<script>
export default {
  props: ['kategori'],
}
</script>
